export enum CartMilestones {
  CLERK_CONTINUE_SELF_ONBOARDING = "ClerkContinueSelfOnboarding",
  CUSTOMER_CONTEACT_INFO_VIEW_LOADED = "CustomerContactInfoViewLoaded",
  CUSTOMER_CLICKED_CONTINUE_ON_CONTECT_INFO_VIEW = "CustomerClickedContinueOnContactInfoView",
  CUSTOMER_ECOMMERCE_FINISHED = "CustomerEcommerceFinished",
  DIRECT_TO_CUSTOMER_FINISHED = "DirectToCustomerFinished",
}
